import { Directive, ElementRef, HostListener, Input} from '@angular/core';
import { CommonService } from '../services/common.service';

@Directive({ selector: '[FocusOnCondition]' })
export class FocusOnConditionDirective {
  @Input() FocusOnCondition: boolean;
  constructor(private _el: ElementRef, private _cs: CommonService) { }
  @HostListener('keydown', ['$event']) onKeyDown(event) {
    if (this.FocusOnCondition === true) {
     const keyCode = event.which;
 
       if(keyCode == 0 && !event.shiftKey){//&& event.target.value
         var data = document?.getElementById("autoCompleteSearch");
         var receiving = document?.getElementById("receivingAutoComplete");
         if(data){
           data.focus();
         }
         else if (receiving){
           receiving.focus();
         }
         return false;
       }
   return true;
   }
 }
}
